import { Link } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useOpenClientDownload } from '@/shared/hooks/useClientDownload';

export function Hero() {
  const { isLoggedIn } = useAuth();
  const openDownload = useOpenClientDownload();
  return (
    <section className="hero" id="home">
      <div className="hero-bg"></div>
      <div className="hero-shade"></div>
      <div className="hero-frame" aria-hidden="true"></div>
      <div className="shell hero-layout">
        <div className="hero-spacer"></div>
        <div className="hero-copy reveal">
          <div className="hero-kicker">O verdadeiro Cabal</div>
          <h1>Nevareth</h1>
          <h2>Chama os livres</h2>
          <p>Duas forças. Um só mundo. A liberdade de explorar,<br />combater e escrever a sua própria história.</p>
          <div className="hero-buttons">
            <Link className="btn btn-gold btn-big" to={isLoggedIn ? '/dashboard' : '/cadastro'}>♙ Jogar agora</Link>
            <button className="btn btn-dark btn-big" onClick={openDownload}>⇩ Baixar cliente</button>
          </div>
        </div>
      </div>
      <div className="side-mantra"><span></span><em>Primeiro<br />servidor<br />episódio 39</em><span></span></div>
      <a className="scroll-cue" href="#noticias" aria-label="Ir para notícias">
        <span className="scroll-cue-mouse"><i></i></span>
        <span className="scroll-cue-arrows"><b></b><b></b></span>
      </a>
    </section>
  );
}
